require("./bootstrap");

jQuery(function () {
  $(document).on("select2:open", function (event) {
    let select2SearchField = $(event.target)
      .parent()
      .find(".select2-search__field");

    if (select2SearchField.length > 0) {
      select2SearchField.focus();
    }
  });

  $('[data-toggle="dropdown"]').dropdown();

  /**
   * Handle popover
   */

  jQuery('[data-toggle="popover"]').popover();
  $("body").on("click", function (e) {
    $('[data-toggle="popover"]').each(function () {
      if (
        !$(this).is(e.target) &&
        $(this).has(e.target).length === 0 &&
        $(".popover").has(e.target).length === 0
      ) {
        $(this).popover("hide");
      }
    });
  });

  /**
   * Handle tooltips.
   */
  let tooltips = $('[data-toggle="tooltip"]').tooltip();

  jQuery("body").on("click", function (e) {
    jQuery(tooltips).each(function () {
      let tooltip = jQuery(this);

      if (tooltip.data("trigger") !== "click") {
        return;
      }

      if (
        !tooltip.is(e.target) &&
        tooltip.has(e.target).length === 0 &&
        jQuery(".tooltip").has(e.target).length === 0
      ) {
        tooltip.tooltip("hide");

        tooltip.removeClass("text-secondary");
        tooltip.addClass("text-primary");
      } else {
        tooltip.removeClass("text-primary");
        tooltip.addClass("text-secondary");
      }
    });
  });

  //Progress bar flow campaign
  $(document).ready(function() {
    let progressBar = $('#progress-bar');
    let steps = $('.step');
    let stopAt = parseInt($('.progress-container').data('progress-stop'));

    function updateProgress() {
      let currentProgress = 0;
      steps.each(function(index, element) {
        let step = $(element);
        let targetProgress = parseInt(step.data('target-progress'));
        if (targetProgress <= stopAt) {
          currentProgress = targetProgress;
          step.addClass('active');
          step.find('i').removeClass('fa-circle').addClass('fa-check');
        } else {
          step.removeClass('active');
          step.find('i').removeClass('fa-check').addClass('fa-circle');
        }
      });
      progressBar.css('width', currentProgress + '%');
    }

    updateProgress();
  });
});
